(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sm-gift-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sm-gift-progress')) {
    class SmGiftProgress extends HTMLElement {
      constructor() {
        super();
        this._onCartUpdate = this._onCartUpdate.bind(this);
      }
      connectedCallback() {
        document.addEventListener('cart:refresh', this._onCartUpdate);
        document.addEventListener('cart-updated', this._onCartUpdate);
        if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          this._unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (payload) => {
            const cart = (payload && payload.cartData) || payload;
            if (!cart) return this._refetch();
            const total = typeof cart.total_price === 'number' ? cart.total_price : null;
            const items = typeof cart.item_count === 'number' ? cart.item_count : null;
            if (total === null || items === null) return this._refetch();
            this._update(total, items);
          });
        }
      }
      disconnectedCallback() {
        document.removeEventListener('cart:refresh', this._onCartUpdate);
        document.removeEventListener('cart-updated', this._onCartUpdate);
        if (this._unsubscribe) this._unsubscribe();
      }
      _onCartUpdate() { this._refetch(); }
      _refetch() {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => this._update(cart.total_price, cart.item_count))
          .catch(() => {});
      }
      _formatMoney(cents) {
        const rupees = Math.ceil(cents / 100);
        return '₹' + rupees.toLocaleString('en-IN');
      }
      _update(total, items) {
        this.dataset.cartTotal = String(total);
        this.dataset.cartItems = String(items);

        const t1th = parseInt(this.dataset.t1Th, 10) || 0;
        const t2th = parseInt(this.dataset.t2Th, 10) || 0;
        const t3th = parseInt(this.dataset.t3Th, 10) || 0;
        const t1min = parseInt(this.dataset.t1Min, 10) || 1;
        const t2min = parseInt(this.dataset.t2Min, 10) || 1;
        const t3min = parseInt(this.dataset.t3Min, 10) || 1;
        const t1title = this.dataset.t1Title || '';
        const t2title = this.dataset.t2Title || '';
        const t3title = this.dataset.t3Title || '';

        let currentTier = 0;
        if (t1th > 0 && t1title && total >= t1th && items >= t1min) currentTier = 1;
        if (t2th > 0 && t2title && total >= t2th && items >= t2min) currentTier = 2;
        if (t3th > 0 && t3title && total >= t3th && items >= t3min) currentTier = 3;

        let unlocked = '';
        if (currentTier === 1) unlocked = t1title;
        else if (currentTier === 2) unlocked = t2title;
        else if (currentTier === 3) unlocked = t3title;

        this.classList.toggle('sm-gift--done', currentTier >= 1);

        const doneEl = this.querySelector('[data-sm-gift-done]');
        const activeEl = this.querySelector('[data-sm-gift-active]');
        const listEl = this.querySelector('[data-sm-gift-list]');

        if (currentTier >= 1) {
          if (doneEl) doneEl.hidden = false;
          if (activeEl) activeEl.hidden = true;
          if (listEl) listEl.textContent = unlocked;
        } else {
          if (doneEl) doneEl.hidden = true;
          if (activeEl) {
            activeEl.hidden = false;
            const line = activeEl.querySelector('[data-sm-gift-line]');
            if (line) {
              const remaining = Math.max(0, t1th - total);
              let html;
              if (remaining > 0) {
                html = 'Add <strong>' + this._formatMoney(remaining) + '</strong> more to unlock <strong>' + (t1title || 'gift') + '</strong>';
                if (items < t1min) html += ' <span class="sm-gift__note">· need ' + t1min + '+ items</span>';
              } else {
                html = 'Add <strong>' + t1min + '+ items</strong> to unlock <strong>' + (t1title || 'gift') + '</strong>';
              }
              line.innerHTML = html;
            }
          }
        }
      }
    }
    customElements.define('sm-gift-progress', SmGiftProgress);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-quickview"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__smQuickViewBound) return;
    window.__smQuickViewBound = true;

    var modal       = document.querySelector('[data-sm-quickview-modal]');
    if (!modal) return;
    var loadingEl   = modal.querySelector('[data-sm-qv-loading]');
    var contentEl   = modal.querySelector('[data-sm-qv-content]');
    var mediaEl     = modal.querySelector('[data-sm-qv-media]');
    var imgEl       = null;
    function ensureImg() {
      if (imgEl) return imgEl;
      imgEl = document.createElement('img');
      imgEl.className = 'sm-qv__media-img';
      imgEl.width = 400;
      imgEl.height = 400;
      imgEl.alt = '';
      imgEl.loading = 'eager';
      mediaEl.appendChild(imgEl);
      return imgEl;
    }
    var titleEl     = modal.querySelector('[data-sm-qv-title]');
    var priceEl     = modal.querySelector('[data-sm-qv-price]');
    var mrpEl       = modal.querySelector('[data-sm-qv-mrp]');
    var discountEl  = modal.querySelector('[data-sm-qv-discount]');
    var descEl      = modal.querySelector('[data-sm-qv-desc]');
    var variantsEl  = modal.querySelector('[data-sm-qv-variants]');
    var qtyInput    = modal.querySelector('[data-sm-qv-qty-input]');
    var addBtn      = modal.querySelector('[data-sm-qv-add]');
    var pdpLink     = modal.querySelector('[data-sm-qv-pdp]');

    var currentProduct = null;

    /* ── Money helper ─────────────────────────────────── */
    function fmtMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(amount); }
      catch (e) { return '₹' + amount; }
    }

    /* ── Modal open/close ─────────────────────────────── */
    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sm-qv-open');
      loadingEl.hidden = false;
      contentEl.hidden = true;
    }
    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sm-qv-open');
      currentProduct = null;
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sm-qv-close]')) { closeModal(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
    });

    /* ── AJAX add-to-cart (shared by card + modal) ────── */
    function setBtnLoading(btn, loading) {
      if (!btn) return;
      btn.classList.toggle('is-loading', !!loading);
      btn.disabled = !!loading;
    }
    function applyCartUpdate(data) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && data && data.sections && typeof cartDrawer.renderContents === 'function') {
        try { cartDrawer.renderContents(data); return; } catch (e) {}
      }
      // Fallback
      if (data && data.sections && data.sections['cart-drawer']) {
        var fragment = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        var newDrawer = fragment.querySelector('#CartDrawer');
        var currentDrawer = document.getElementById('CartDrawer');
        if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
      }
      var trigger = document.getElementById('cart-icon-bubble');
      if (trigger) trigger.click();
    }
    function smAddToCart(variantId, qty, btn, opts) {
      opts = opts || {};
      if (!variantId) return Promise.reject(new Error('No variant'));
      setBtnLoading(btn, true);
      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', qty || 1);
      fd.append('sections', 'cart-drawer');
      fd.append('sections_url', window.location.pathname);

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      if (!/\.js$/.test(addUrl)) addUrl = addUrl.replace(/\/$/, '') + '.js';

      return fetch(addUrl, {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          applyCartUpdate(data);
          if (opts.afterAdd) opts.afterAdd();
        })
        .catch(function (err) {
          console.error('Add to cart failed:', err);
          var msg = (err && (err.description || err.message)) || 'Could not add';
          if (btn) {
            var lbl = btn.querySelector('.sm-pcard__qa-label, .sm-qv__add-label, .sm-pdp__btn-text')
              || btn.querySelector('span');
            if (lbl) {
              var prev = lbl.innerHTML;
              var displayMsg = /sold out/i.test(msg) ? 'Sold out' : (msg.length > 32 ? 'Try again' : msg);
              lbl.textContent = displayMsg;
              setTimeout(function () { lbl.innerHTML = prev; }, 2200);
            }
          }
        })
        .finally(function () { setBtnLoading(btn, false); });
    }
    // Expose for other scripts
    window.smAddToCart = smAddToCart;

    /* ── Card "Add to Cart" trigger ───────────────────── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-card-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-sm-variant-id');
      smAddToCart(variantId, 1, btn);
    });

    /* ── Card "Quick View" trigger ────────────────────── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-card-quickview]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-sm-handle');
      var url = btn.getAttribute('data-sm-url') || ('/products/' + handle);
      openModal();
      fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) {
          currentProduct = product;
          renderQuickView(product, url);
        })
        .catch(function () { window.location.href = url; });
    });

    /* ── Render product into modal ────────────────────── */
    function renderQuickView(p, url) {
      // Image
      var firstImg = (p.featured_image || (p.images && p.images[0]) || '').toString();
      if (firstImg && firstImg.indexOf('//') === 0) firstImg = 'https:' + firstImg;
      var img = ensureImg();
      img.src = firstImg;
      img.alt = p.title || '';

      titleEl.textContent = p.title || '';
      pdpLink.href = url || ('/products/' + p.handle);

      var current = pickInitialVariant(p);
      applyVariant(current);

      // Description (strip HTML, take first ~200 chars)
      var div = document.createElement('div');
      div.innerHTML = p.description || '';
      descEl.textContent = (div.textContent || '').trim();

      // Build variant pickers
      variantsEl.innerHTML = '';
      if (p.options && p.options.length && !(p.options.length === 1 && (p.options[0] === 'Title' || p.options[0].name === 'Title'))) {
        p.options.forEach(function (optName, optIdx) {
          var name = (typeof optName === 'string') ? optName : optName.name;
          var values = [];
          p.variants.forEach(function (v) {
            var val = v.options[optIdx];
            if (val && values.indexOf(val) === -1) values.push(val);
          });

          var fs = document.createElement('div');
          fs.className = 'sm-qv__opt';
          fs.dataset.optionIndex = optIdx;

          var lbl = document.createElement('div');
          lbl.className = 'sm-qv__opt-label';
          lbl.innerHTML = '<span>' + escapeHtml(name) + '</span><span class="sm-qv__opt-selected" data-sm-qv-opt-selected>' + escapeHtml(current.options[optIdx] || '') + '</span>';
          fs.appendChild(lbl);

          var wrap = document.createElement('div');
          wrap.className = 'sm-qv__opt-values';
          values.forEach(function (val, vi) {
            var id = 'qv-opt-' + optIdx + '-' + vi;
            var input = document.createElement('input');
            input.type = 'radio';
            input.id = id;
            input.name = 'qv-opt-' + optIdx;
            input.value = val;
            input.className = 'sm-qv__opt-input';
            if (val === current.options[optIdx]) input.checked = true;
            input.addEventListener('change', onOptionChange);
            var label = document.createElement('label');
            label.htmlFor = id;
            label.className = 'sm-qv__opt-pill';
            label.textContent = val;
            wrap.appendChild(input);
            wrap.appendChild(label);
          });
          fs.appendChild(wrap);
          variantsEl.appendChild(fs);
        });
      }

      qtyInput.value = 1;
      loadingEl.hidden = true;
      contentEl.hidden = false;
    }

    function pickInitialVariant(p) {
      // Prefer first available
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available) return p.variants[i];
      }
      return p.variants[0];
    }

    function onOptionChange() {
      if (!currentProduct) return;
      var fieldsets = variantsEl.querySelectorAll('.sm-qv__opt');
      var selected = [];
      fieldsets.forEach(function (fs, idx) {
        var checked = fs.querySelector('.sm-qv__opt-input:checked');
        if (checked) selected.push(checked.value);
        var lbl = fs.querySelector('[data-sm-qv-opt-selected]');
        if (lbl && checked) lbl.textContent = checked.value;
      });
      var match = currentProduct.variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      if (match) applyVariant(match);
    }

    function applyVariant(v) {
      if (!v) return;
      addBtn.dataset.variantId = v.id;
      priceEl.textContent = fmtMoney(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        mrpEl.textContent = fmtMoney(v.compare_at_price);
        mrpEl.hidden = false;
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        discountEl.textContent = 'SAVE ' + pct + '%';
        discountEl.hidden = false;
      } else {
        mrpEl.hidden = true;
        discountEl.hidden = true;
      }
      if (v.available) {
        addBtn.disabled = false;
        var lbl = addBtn.querySelector('.sm-qv__add-label');
        if (lbl) lbl.lastChild ? (lbl.lastChild.nodeValue = ' Add to Cart') : null;
      } else {
        addBtn.disabled = true;
        var lbl2 = addBtn.querySelector('.sm-qv__add-label');
        if (lbl2) lbl2.lastChild ? (lbl2.lastChild.nodeValue = ' Sold out') : null;
      }
      // Swap image if variant has its own
      if (v.featured_image && v.featured_image.src && imgEl) {
        var src = v.featured_image.src;
        if (src.indexOf('//') === 0) src = 'https:' + src;
        imgEl.src = src;
      }
    }

    /* ── Modal qty stepper ────────────────────────────── */
    modal.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-qv-qty]');
      if (!btn) return;
      var step = parseInt(btn.getAttribute('data-sm-qv-qty'), 10);
      var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
      qtyInput.value = val;
    });

    /* ── Modal Add to Cart ────────────────────────────── */
    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = addBtn.dataset.variantId;
      var qty = parseInt(qtyInput.value, 10) || 1;
      smAddToCart(variantId, qty, addBtn, {
        afterAdd: function () { closeModal(); }
      });
    });

    /* ── Helpers ──────────────────────────────────────── */
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sm-rail')) {
    class SmRail extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('[data-sm-rail-track]') || this.firstElementChild;
        this._prev = this.querySelector('[data-sm-rail-prev]');
        this._next = this.querySelector('[data-sm-rail-next]');
        if (!this._track) return;

        this._onScroll = this._onScroll.bind(this);
        this._track.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);

        if (this._prev) this._prev.addEventListener('click', () => this._scroll(-1));
        if (this._next) this._next.addEventListener('click', () => this._scroll(1));

        this._update();
      }
      disconnectedCallback() {
        if (this._track) this._track.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
      }
      _step() {
        var first = this._track.firstElementChild;
        if (!first) return this._track.clientWidth;
        var rect = first.getBoundingClientRect();
        var styles = window.getComputedStyle(this._track);
        var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return rect.width + gap;
      }
      _scroll(direction) {
        this._track.scrollBy({ left: direction * this._step(), behavior: 'smooth' });
      }
      _onScroll() { this._update(); }
      _update() {
        var t = this._track;
        if (!t) return;
        var max = t.scrollWidth - t.clientWidth;
        var atStart = t.scrollLeft <= 1;
        var atEnd = t.scrollLeft >= max - 1;
        if (this._prev) this._prev.hidden = atStart;
        if (this._next) this._next.hidden = atEnd || max <= 1;
      }
    }
    customElements.define('sm-rail', SmRail);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-review-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__smRevLbBound) return;
    window.__smRevLbBound = true;

    var lb = document.querySelector('[data-sm-rev-lightbox]');
    if (!lb) return;
    // Hoist to <body> so fixed positioning + backdrop escape any section stacking context
    if (lb.parentNode !== document.body) document.body.appendChild(lb);

    var imgEl = lb.querySelector('[data-sm-lb-img]');
    var counter = lb.querySelector('[data-sm-lb-counter]');
    var prevBtn = lb.querySelector('[data-sm-lb-prev]');
    var nextBtn = lb.querySelector('[data-sm-lb-next]');
    var avatarEl = lb.querySelector('[data-sm-lb-avatar]');
    var nameEl = lb.querySelector('[data-sm-lb-name]');
    var dateEl = lb.querySelector('[data-sm-lb-date]');
    var verifiedEl = lb.querySelector('[data-sm-lb-verified]');
    var starsEl = lb.querySelector('[data-sm-lb-stars]');
    var bodyEl = lb.querySelector('[data-sm-lb-body]');
    var imgs = [], idx = 0;

    function starStr(n) { var s = ''; for (var i = 1; i <= 5; i++) s += '<span class="' + (i <= n ? '' : 'off') + '">★</span>'; return s; }
    function fmtDate(raw) { if (!raw) return ''; var d = new Date(String(raw).replace(' UTC', 'Z').replace(' ', 'T')); return isNaN(d) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); }

    function renderImg() {
      imgEl.src = imgs[idx] || '';
      counter.textContent = imgs.length > 1 ? (idx + 1) + ' / ' + imgs.length : '';
      var multi = imgs.length > 1;
      prevBtn.style.display = multi ? '' : 'none';
      nextBtn.style.display = multi ? '' : 'none';
    }
    function open(arr, i, meta) {
      imgs = arr || []; idx = i || 0; if (!imgs.length) return;
      meta = meta || {};
      var nm = (meta.name || 'Anonymous').trim();
      var np = nm.split(/\s+/).filter(Boolean);
      avatarEl.textContent = ((np[0] || 'A').charAt(0) + (np.length > 1 ? np[np.length - 1].charAt(0) : '')).toUpperCase();
      nameEl.textContent = nm;
      dateEl.textContent = fmtDate(meta.date);
      verifiedEl.hidden = !meta.verified;
      starsEl.innerHTML = meta.rating ? starStr(meta.rating) : '';
      bodyEl.textContent = meta.body || '';
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      renderImg();
    }
    function close() { lb.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    function go(d) { if (!imgs.length) return; idx = (idx + d + imgs.length) % imgs.length; renderImg(); }

    lb.querySelectorAll('[data-sm-lb-close]').forEach(function (b) { b.addEventListener('click', close); });
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    document.addEventListener('keydown', function (e) {
      if (lb.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });

    document.addEventListener('click', function (e) {
      var pic = e.target.closest('[data-sm-rev-pic]');
      if (!pic) return;
      var wrap = pic.closest('[data-sm-rev-gallery]');
      if (!wrap) return;
      var arr, meta;
      try { arr = JSON.parse(wrap.getAttribute('data-sm-rev-gallery') || '[]'); } catch (err) { arr = []; }
      try { meta = JSON.parse(wrap.getAttribute('data-sm-rev-meta') || '{}'); } catch (err2) { meta = {}; }
      open(arr, parseInt(pic.getAttribute('data-index'), 10) || 0, meta);
    });

    var sx = null;
    imgEl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    imgEl.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null; if (Math.abs(dx) > 40) go(dx > 0 ? -1 : 1); }, { passive: true });

    window.smReviewLightbox = { open: open };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sm-wishlist"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.smWishlist) return;

    var KEY = 'sm_wishlist';

    function read() {
      try {
        var raw = localStorage.getItem(KEY);
        var arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    }

    function write(arr) {
      try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
      broadcast();
    }

    function has(id) {
      id = String(id);
      return read().some(function (p) { return String(p.id) === id; });
    }

    function add(product) {
      if (!product || !product.id) return false;
      var arr = read();
      if (arr.some(function (p) { return String(p.id) === String(product.id); })) return false;
      arr.unshift(Object.assign({ added_at: Date.now() }, product));
      write(arr);
      return true;
    }

    function remove(id) {
      id = String(id);
      var arr = read().filter(function (p) { return String(p.id) !== id; });
      write(arr);
    }

    function toggle(product) {
      if (!product || !product.id) return false;
      if (has(product.id)) {
        remove(product.id);
        return false;
      }
      add(product);
      return true;
    }

    function count() { return read().length; }
    function list()  { return read(); }
    function clear() { write([]); }

    function broadcast() {
      var c = count();
      // Update count text
      document.querySelectorAll('[data-sm-wish-count]').forEach(function (el) {
        el.textContent = c;
      });
      // Show/hide count badge inside header heart wrapper
      document.querySelectorAll('[data-sm-wish-count-badge]').forEach(function (wrap) {
        var badge = wrap.querySelector('.sm-icon-btn__badge');
        if (!badge) return;
        if (c > 0) {
          badge.textContent = c;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
      // Empty state toggling
      document.querySelectorAll('[data-sm-wish-empty]').forEach(function (el) {
        el.classList.toggle('is-empty', c === 0);
      });
      // Sync all toggle buttons
      syncToggles();
      // Custom event for any subscriber
      document.dispatchEvent(new CustomEvent('sm:wishlist:change', { detail: { count: c, items: read() } }));
    }

    function syncToggles() {
      var ids = read().map(function (p) { return String(p.id); });
      document.querySelectorAll('[data-sm-wish-toggle]').forEach(function (btn) {
        var id = parseProduct(btn).id;
        var on = id && ids.indexOf(String(id)) !== -1;
        btn.classList.toggle('is-wishlisted', !!on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function parseProduct(btn) {
      try { return JSON.parse(btn.getAttribute('data-product') || '{}'); }
      catch (e) { return {}; }
    }

    /* ── Auto-bind toggle clicks ──────────────────────────── */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-wish-toggle]');
      if (!btn) return;
      e.preventDefault();
      var product = parseProduct(btn);
      if (!product || !product.id) return;
      var added = toggle(product);
      btn.classList.add('sm-wish-pop');
      setTimeout(function () { btn.classList.remove('sm-wish-pop'); }, 360);
      // Tiny visual nudge
      btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');
    });

    /* ── Cross-tab sync ───────────────────────────────────── */
    window.addEventListener('storage', function (e) {
      if (e.key === KEY) broadcast();
    });

    /* ── Initial sync after DOM ready ─────────────────────── */
    function init() { broadcast(); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.smWishlist = {
      add: add, remove: remove, toggle: toggle,
      has: has, count: count, list: list, clear: clear
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
